"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwPodGrid = _interopRequireDefault(require("./CwPodGrid.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CwPodGridLoader = _interopRequireDefault(require("./CwPodGridLoader"));

var CwPodGrid = function CwPodGrid(props) {
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(props.gwtStandalonePod ? _CwPodGrid.default.podGridNoPadding : _CwPodGrid.default.podGrid, (0, _defineProperty2.default)({}, _CwPodGrid.default.defaultLayout, !props.customLayout))
  }, props.loader(props));
};

CwPodGrid.propTypes = {
  maxColumns: _propTypes.default.number,
  customLayout: _propTypes.default.bool,
  loader: _propTypes.default.func,
  gwtStandalonePod: _propTypes.default.bool
};
CwPodGrid.defaultProps = {
  maxColumns: 2,
  loader: _CwPodGridLoader.default
};
var _default = CwPodGrid;
exports.default = _default;